export default __webpack_public_path__ + "static/top-44a8ca1f731bf20850030e53fd98d898.png";